import { useRef } from "react";
import useInView from "@/hooks/useInView";

export default function AnimatedSection({ children, className = "", id, testId, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref);

  return (
    <section
      id={id}
      ref={ref}
      data-testid={testId}
      className={`${className} transition-all duration-1000 ease-out ${
        isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </section>
  );
}
